"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.jobsToolbarFactory = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const detail_context_1 = require("../../../composite/detail/detail-context");
const detail_types_1 = require("../../../composite/detail/detail-types");
const jobs_api_1 = require("./jobs-api");
const detail_toolbar_button_action_1 = require("../../../composite/detail/detail-toolbar-button-action");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const schedule_context_1 = require("../schedule-context");
function jobsToolbarFactory({ ButtonComponent, }) {
    return function JobsToolbar() {
        var _a;
        const intl = react_intl_1.useIntl();
        const { jobUrl } = react_1.useContext(schedule_context_1.ScheduleContext);
        const { isExisting, source } = react_1.useContext(detail_context_1.DetailContext);
        const running = (_a = source.data) === null || _a === void 0 ? void 0 : _a.running;
        const start = event_callback_hook_1.useEventCallback((id) => {
            return jobs_api_1.startCall(jobUrl, id);
        });
        const cancel = event_callback_hook_1.useEventCallback((id) => {
            return jobs_api_1.cancelCall(jobUrl, id);
        });
        return (react_1.default.createElement(react_1.default.Fragment, null, isExisting && (react_1.default.createElement(react_1.default.Fragment, null,
            !running && (react_1.default.createElement(detail_toolbar_button_action_1.DetailToolbarButtonAction, { ButtonComponent: ButtonComponent, buttonProps: {
                    type: detail_types_1.DetailToolbarButtonType.PRIMARY,
                }, promptKey: "MAIL_CAMPAIGN_CHECK", apiCall: start, buttonLabel: intl.formatMessage({
                    id: 'EAS_SCHEDULE_JOBS_TOOLBAR_BTN_START',
                    defaultMessage: 'Spustit',
                }), buttonTooltip: intl.formatMessage({
                    id: 'EAS_SCHEDULE_JOBS_TOOLBAR_TOOLTIP_START',
                    defaultMessage: 'Otevrě dialog pro potvrzení spustění úlohy',
                }), dialogTitle: intl.formatMessage({
                    id: 'EAS_SCHEDULE_JOBS_START_DIALOG_TITLE',
                    defaultMessage: 'Varování',
                }), dialogText: intl.formatMessage({
                    id: 'EAS_SCHEDULE_JOBS_START_DIALOG_TEXT',
                    defaultMessage: 'Skutečně chcete spustit úlohu?',
                }), successMessage: intl.formatMessage({
                    id: 'EAS_SCHEDULE_JOBS_MSG_START_SUCCESS',
                    defaultMessage: 'Úloha byla úspěšně spuštěna.',
                }), errorMessage: intl.formatMessage({
                    id: 'EAS_SCHEDULE_JOBS_MSG_START_ERROR',
                    defaultMessage: 'Nastala chyba.',
                }) })),
            running && (react_1.default.createElement(detail_toolbar_button_action_1.DetailToolbarButtonAction, { ButtonComponent: ButtonComponent, buttonProps: {
                    type: detail_types_1.DetailToolbarButtonType.PRIMARY,
                }, promptKey: "MAIL_CAMPAIGN_CHECK", apiCall: cancel, buttonLabel: intl.formatMessage({
                    id: 'EAS_SCHEDULE_JOBS_TOOLBAR_BTN_CANCEL',
                    defaultMessage: 'Zastavit',
                }), buttonTooltip: intl.formatMessage({
                    id: 'EAS_SCHEDULE_JOBS_TOOLBAR_TOOLTIP_CANCEL',
                    defaultMessage: 'Otevrě dialog pro potvrzení zastavení úlohy',
                }), dialogTitle: intl.formatMessage({
                    id: 'EAS_SCHEDULE_JOBS_CANCEL_DIALOG_TITLE',
                    defaultMessage: 'Varování',
                }), dialogText: intl.formatMessage({
                    id: 'EAS_SCHEDULE_JOBS_CANCEL_DIALOG_TEXT',
                    defaultMessage: 'Zastavení běžící úlohy může spůsobit inkonzistenci dat. Skutečně chcete zastavit běžící úlohu?',
                }), successMessage: intl.formatMessage({
                    id: 'EAS_SCHEDULE_JOBS_MSG_CANCEL_SUCCESS',
                    defaultMessage: 'Úloha byla úspěšně zrušena.',
                }), errorMessage: intl.formatMessage({
                    id: 'EAS_SCHEDULE_JOBS_MSG_CANCEL_ERROR',
                    defaultMessage: 'Nastala chyba.',
                }) }))))));
    };
}
exports.jobsToolbarFactory = jobsToolbarFactory;
//# sourceMappingURL=jobs-toolbar.js.map